import { trackEventFromState } from '@eb/site-analytics';

import { SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE } from '@eb/social-login-facebook';
import { GA_AUTH_CATEGORY, GA_LOGIN_INVALID_PASSWORD } from '../constants';
import {
    GA_SIWA_EMAIL_ALREADY_EXISTS,
    GA_HIDDEN_EMAIL,
    GA_SHOWED_EMAIL,
    GA_EMAIL_NOT_FOUND,
    GA_SIWA_ACCOUNTS_LINK_OPTION,
    GA_LINK_ACCOUNT_OPTION,
    GA_SIWA_ACCOUNT_CREATED,
    GA_SIWA_ACCOUNT_CREATED_FAILED,
} from '../constants/analytics';

// SIWA flow metrics

/****************************
 * User doesn't share email *
 ****************************/

// User has an EB account
export const trackSIWA_LookUpSuccessWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_HIDDEN_EMAIL,
    });
};

// User has an EB account, enters wrong password
export const trackSIWA_WrongPassword = (state) => {
    trackEventFromState(state, {
        action: GA_LOGIN_INVALID_PASSWORD,
        category: GA_AUTH_CATEGORY,
        label: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    });
};

// User has an EB account, successfuly link their account
// export const trackSuccessfullyLinkAccountsWithExistingEBAccount = (
//     sourceProvider,
// ) => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

// User doesn't has an EB account, enters an email that isn't an EB account
export const trackSIWA_EmailNotFound = (state) => {
    trackEventFromState(state, {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_EMAIL_NOT_FOUND,
    });
};

// User doesn't has an EB account, enters an email that isn't an EB account, successfuly link their account
// export const trackSuccessfullyLinkAccountsWithoutEBAccount = (
//     sourceProvider,
// ) => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

// User doesn't has an EB account, enters an email that isn't an EB account, wrong password - Possible?
// export const trackWrongPasswordOnLinkAccountsWithoutEBAccount = (
//     sourceProvider,
// ) => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_LOGIN_INVALID_PASSWORD,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

// track accounts linked when user hide the email but add EB account on page load
export const trackSIWA_AccountsLinkOptionWithHiddenEmail = (hidden) => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_ACCOUNTS_LINK_OPTION,
        category: GA_AUTH_CATEGORY,
        label: hidden ? GA_HIDDEN_EMAIL : GA_SHOWED_EMAIL,
    });
};

// track account created when user hide his email and doesn't have an EB account
export const trackSIWA_AccountCreatedWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_ACCOUNT_CREATED,
        category: GA_AUTH_CATEGORY,
        label: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    });
};

// track when user wants to link his account with an EB account
export const trackSIWA_AccountLinkAttemptWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_LINK_ACCOUNT_OPTION,
    });
};

/****************************
 *     User share email     *
 ****************************/

// track successfuly login with showed email
export const trackSIWA_LookUpSuccessWithEmail = () => (dispatch, getState) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_SHOWED_EMAIL,
    });
};

/*
 * User enter wrong password for his EB account
 */
// export const trackSIWA_WrongPasswordWithEBAccount = (sourceProvider) => (
//     dispatch,
//     getState,
// ) => {
//     trackEventFromState(getState(), {
//         action: GA_LOGIN_INVALID_PASSWORD,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

/*
 * User successfuly link their account
 */
// export const trackSIWA_LinkAccountWithEBAccount = (sourceProvider) => (
//     dispatch,
//     getState,
// ) => {
//     trackEventFromState(getState(), {
//         action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

/*
 * User enter an email that isn't an EB account
 */
// export const trackSIWAEmailNotFound = () => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_SIWA_EMAIL_ALREADY_EXISTS,
//         category: GA_AUTH_CATEGORY,
//         label: GA_EMAIL_NOT_FOUND,
//     });
// };

export const trackSIWA_errorOnNewUser = (state, label) => {
    trackEventFromState(state, {
        action: GA_SIWA_ACCOUNT_CREATED_FAILED,
        category: GA_AUTH_CATEGORY,
        label,
    });
};
